export default [
  {
    orderID:"1225574",
    customdutycharges:"62",
    amount:"754",
    status:"Refunded"
  },
  {
    orderID:"6525891",
    customdutycharges:"44",
    amount:"499",
    status:"Pending"
  },
  {
    orderID:"5225674",
    customdutycharges:"47",
    amount:"599",
    status:"Refunded"
  },
  {
    orderID:"4525831",
    customdutycharges:"25",
    amount:"589",
    status:"Pending"
  }
];
